import { render, staticRenderFns } from "./rate_student_class.vue?vue&type=template&id=04d074ec&scoped=true"
import script from "./rate_student_class.vue?vue&type=script&lang=js"
export * from "./rate_student_class.vue?vue&type=script&lang=js"
import style0 from "../assets/styles/student-review.scss?vue&type=style&index=0&id=04d074ec&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d074ec",
  null
  
)

export default component.exports